import { useState, useEffect } from 'react';
import { routingService } from './routingService';

export const useRouting = () => {
  const [currentApp, setCurrentApp] = useState<string | null>(routingService.getCurrentApp());

  useEffect(() => {
    const handleRouteChange = (event: CustomEvent) => {
      setCurrentApp(event.detail.currentApp);
    };

    // Escuchar cambios de ruta
    window.addEventListener('routechange', handleRouteChange as EventListener);

    return () => {
      window.removeEventListener('routechange', handleRouteChange as EventListener);
    };
  }, []);

  const navigateToApp = (appId: string) => {
    routingService.navigateToApp(appId);
  };

  const navigateToPortal = () => {
    routingService.navigateToPortal();
  };

  const isInPortal = () => {
    return routingService.isInPortal();
  };

  const isInApp = (appId: string) => {
    return routingService.isInApp(appId);
  };

  return {
    currentApp,
    navigateToApp,
    navigateToPortal,
    isInPortal,
    isInApp
  };
};
